/**
 * @param {string} locale - The locale for the file to load
 * @returns {Promise} - The loaded file
 */
export default async function importTranslationFile(locale) {
	switch (locale) {
		case 'cs':
			return await import('#src/translations/cs.json')
		case 'da':
			return await import('#src/translations/da.json')
		case 'de':
			return await import('#src/translations/de.json')
		case 'es':
			return await import('#src/translations/es.json')
		case 'fr':
			return await import('#src/translations/fr.json')
		case 'it':
			return await import('#src/translations/it.json')
		case 'nl':
			return await import('#src/translations/nl.json')
		case 'pl':
			return await import('#src/translations/pl.json')
		case 'pt':
			return await import('#src/translations/pt.json')
		case 'sv':
			return await import('#src/translations/sv.json')
		case 'en':
		default:
			return await import('#src/translations/en.json')
	}
}
